// ── API base URL ────────────────────────────────────────────
// In dev, Vite proxies /api/* to the backend (relative paths work).
// In production, we need the full Render URL from VITE_API_URL.
//
// VITE_API_URL should be set at build time, e.g.:
//   VITE_API_URL=https://pulsedge-api.onrender.com

const API_BASE = import.meta.env.VITE_API_URL || ''

/**
 * Build a full API URL from a path like '/api/engine/stats'
 * Dev:  '/api/engine/stats'  (Vite proxy handles it)
 * Prod: 'https://pulsedge-api.onrender.com/api/engine/stats'
 */
export function apiUrl(path) {
  return `${API_BASE}${path}`
}

export default API_BASE
